import { render, staticRenderFns } from "./ad-chart-legend.vue?vue&type=template&id=fc9580ee"
import script from "./ad-chart-legend.vue?vue&type=script&lang=ts"
export * from "./ad-chart-legend.vue?vue&type=script&lang=ts"
import style0 from "./ad-chart-legend.vue?vue&type=style&index=0&id=fc9580ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports